import { type Filter, type FilterFieldType } from "~/utils/filter"
import FilterPopoverBase from "./FilterPopoverBase"

interface FilterPopoverProps {
  editingFilter?: Filter
  editingFilterIndex?: number
  customTrigger?: React.ReactNode
  align?: "start" | "center" | "end"
  shortcutEnabled?: boolean
  registerSearchCommands?: boolean
  editGroup?: boolean
  extraFilterFields?: FilterFieldType[]
  extraFilterOptions?: React.ReactNode
}

export default function FilterPopover(props: FilterPopoverProps) {
  return <FilterPopoverBase {...props} />
}
